import { useTranslation } from "react-i18next";
import { setToolApproval, type ListedConnector, type ToolApprovalMode } from "../../../api/connectorsApi";
import ErrorNotice from "../../../errors/ErrorNotice";
import { useSubmission } from "../../../shared/state/useSubmission";
import SegmentedControl from "../../../ui/navigation/SegmentedControl";

/**
 * A PC's tool approval, a setting in the app as in T3 Code (Johannes, 3 Nov 18:47): new tool
 * versions run without asking, or the Run asks its host. The server keeps it and sends it with
 * each run; the PC prompts nothing either way. Built provisionally, awaiting acceptance.
 */
export default function PcToolApproval({ connector, onChanged }: { connector: ListedConnector; onChanged: () => void }) {
  const { t } = useTranslation();
  const { state, submit } = useSubmission();
  const choose = (mode: ToolApprovalMode) => {
    if (mode === connector.toolApproval || state.status === "submitting") return;
    submit(async () => {
      await setToolApproval(connector.connectorId, mode);
      onChanged();
    });
  };
  const label = t("connectors.list.toolApproval.label");
  return (
    <div className="space-y-1">
      <div className="flex flex-wrap items-center gap-2">
        <span className="app-text-muted">{label}</span>
        <SegmentedControl<ToolApprovalMode>
          label={label}
          size="small"
          selected={connector.toolApproval}
          onSelect={choose}
          options={[
            { key: "automatic", label: t("connectors.list.toolApproval.automatic"), title: t("connectors.list.toolApproval.automaticHint") },
            { key: "ask_in_app", label: t("connectors.list.toolApproval.askInApp"), title: t("connectors.list.toolApproval.askInAppHint") },
          ]}
        />
      </div>
      {state.status === "failed" ? <ErrorNotice error={state.error} compact /> : null}
    </div>
  );
}
